import type { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<title>Copy</title>
		<rect
			x="8"
			y="8"
			width="12"
			height="12"
			rx="2"
			stroke="var(--svg-color, currentColor)"
			strokeWidth="2"
		/>
		<path
			d="M16 8V6C16 4.89543 15.1046 4 14 4H6C4.89543 4 4 4.89543 4 6V14C4 15.1046 4.89543 16 6 16H8"
			stroke="var(--svg-color, currentColor)"
			strokeWidth="2"
		/>
	</svg>
);
export { SvgComponent as CopyIcon };
